import React, {PureComponent} from 'react';

export default class YoutTubePlayer extends PureComponent {
  render() {
    return <iframe
      className="video-player-external"
      src={`//www.youtube.com/embed/${this.props.embed}?autoplay=${this.props.autoplay}`}
      frameBorder="0"
      scrolling="no"
      allowFullScreen={true} />;
  }
}